import { IRemapper } from "../../../../Global/IRemapper";
import ConsentModel from "../Consent/ConsentModel";
import ConsentRequestBody from "../Consent/ConsentRequestBody";

export default class ConsentRemapper implements IRemapper<ConsentModel[]> {
  toRequest(consents: ConsentRequestBody[]) {
    const requestBody = {
      consent_data: consents.map((c) => {
        return {
          consent_id: c.consentId,
          entity_id: c.entityId || null,
          entity_type: c.entityType || null,
          content: c.content || null,
        };
      }),
    };

    return requestBody;
  }

  fromResponse(response: any): ConsentModel[] {
    return response.map((r) => {
      const model = new ConsentModel();

      model.consentId = r.consent_id;
      model.entityId = r.entity_id;
      model.entityType = r.entity_type;
      model.content = r.content;
      model.consentedAt = r.consented_at;

      return model;
    });
  }
}
